import { TableRes } from '../global'
import { adjustTypeList } from '../pages/MaterialPriceAdjustment'
import request from '../tools/request'
import { GetLocalStorage, getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
const { GET, POST, downFilePost } = request

// 物料库存详情
export type ReturnDetail = {
  brandName: string
  code: string
  isDelisting: string
  isFreeShipping: string
  isPhaseOut: string
  areaInventoryList: any[]
  manuCode: string
  marketPrice: string
  mdmId: string
  name: string
  netWeight: string
  pushPlatformCodeAndNames: any[]
  relationPlatformCodeAndNames: any[]
  srmProductType: string
  srmProductTypeName: string
  supplyPrice: string
  unitName: string
}

// 获取库存管理列表
export const GET_STOCK_LIST = (param: {
  pageNo: number
  pageSize: number
  model: string
  productCode: string
  productName: string
  schemeId: string
  supplierId: string
  userId: string
  platformCode: string
}) =>
  GET<TableRes<ReturnDetail>>(`${HTTP}/product/getNewStockList`, {
    ...param,
    supplierId: getSupplierId(),
    mdmCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
  })

// 修改物料库存
export const UPDATE_STOCK = (params: {
  inventoryInformation: any
  productCode: string
  platformCode: string
}) =>
  POST(
    `${HTTP}/product/updateNewStock`,
    {
      ...params,
      userName: GetLocalStorage('USER_NAME'),
    },
    'application/json',
  )

// 获取当前项目
export const GET_PROJECT = () =>
  GET(`${HTTP}/product/getSupplierPerformanceDTOList`, {
    supplierId: getSupplierId(),
  })

// 获取库存区域详情
export const GET_INVENTORYDETAIL = (params: {
  productCode: string
  platformCode: string
}) =>
  GET(`${HTTP}/product/getMDMProductInventoryDetail`, {
    ...params,
  })

// 根据平台编码查询地址信息(对接MPM第三方平台)
export const GET_PRODUCTAREA = (params: { platformCode: string }) =>
  GET(`${HTTP}/product/getMDMAddressByType`, {
    ...params,
  })

// 下载导入模板
export const DOWNLOAD_PRODUCT = (params: { platformCode: string }) =>
  downFilePost(
    `${HTTP}/product/productStockImportForPlatformAddress?platformCode=${params.platformCode}`,
  )

// 修改库存状态
export const UPDATE_STOCKSTATUS = (params: {
  inventoryStatus: string
  id: string
}) =>
  POST(
    `${HTTP}/product/updateStockStatus`,
    {
      ...params,
      supplierId: getSupplierId(),
      supplierName: GetLocalStorage('HOME_DATA')?.enterpriseName,
    },
    'application/json',
  )

// 导出库存物料
export const PRODUCT_STOCK_EXPORT = (params: {
  platformCode: string
  platformName: string | undefined
}) =>
  POST(
    `${HTTP}/product/productStockExport`,
    {
      ...params,
      supplierId: getSupplierId(),
      userId: getUserId(),
      mdmCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
    },
    'multipart/form-data',
  )

// 导入库存物料
export const PRODUCT_STOCK_IMPORT = (params: {
  file: any
  platformCode: string
}) =>
  POST(
    `${HTTP}/product/productStockImport`,
    {
      ...params,
      supplierId: getSupplierId(),
      userId: getUserId(),
    },
    'multipart/form-data',
  )

// 国网物料
export interface GwProductItem {
  mallLink: any
  adjustPrice: boolean // 是否可调价
  brandName: string // 品牌名称
  causeOfRejection: string // 驳回原因
  code: string // 物料编码
  gwCode: string // 国网物料编码
  gwProductSerialNumber: string // 国网商品编码
  highestChangePrice: string // 最高可改价
  lastCause: boolean // 上次是否驳回
  name: string // 物料名称
  regionalPrice: string // 专区价
  manuCode: string // 规格型号
}

// 获取国网物料列表
export const GET_GW_PLATFORM_PRODUCT_PAGE = (param: {
  gwCode: string // 国网物料编码
  pageNo: number
  pageSize: number
  proName: string // 物料名称
  productCode: string // 物料编码
  schemeId: string
}) =>
  GET<TableRes<GwProductItem>>(`${HTTP}/product/getGwPlatformProductPage`, {
    ...param,
    supplierCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
    userId: getUserId(),
  })

// 获取国网物料列表权限
export const GET_GW_PLATFORM_PRODUCT_PERMISSION = () =>
  GET(`${HTTP}/product/getGwPlatformProductPermission`)

// 国网物料调价入参
type AdjustTypeKey = (typeof adjustTypeList)[number]['key']
export interface AdjustPriceParams {
  id: string
  code: string // 物料编码
  adjustType: AdjustTypeKey // 调价类型
  remark?: string // 备注
  adjustPrice?: string // 调价金额
}

// 国网物料调价
export const APPLY_FOR_PRICE_ADJUSTMENT = (params: AdjustPriceParams) =>
  POST(
    `${HTTP}/product/applyForPriceAdjustment`,
    {
      ...params,
      supplierCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
      supplierId: getSupplierId(),
      supplierName: GetLocalStorage('HOME_DATA')?.enterpriseName,
    },
    'application/json',
  )

/**
 * 唤醒机器人 获取id
 * @param gwProductSerialNumber 国网商品编码
 */
export const ROUSE_ROBOT = (params: { gwProductSerialNumber: string }) =>
  GET(`${HTTP}/product/rouseRobot`, params)

/**
 * 根据id获取价格
 * @param gwProductSerialNumber  国网商品编码
 * @param taskId  任务id
 */
export const QUERY_ROBOT_EXECUTION_RESULT = (params: {
  taskId: string
  gwProductSerialNumber: string
}) => GET(`${HTTP}/product/queryRobotExecutionResult`, params)

/**
 * 保存国网最低价
 * @param code 物料编码
 * @param price 最低价
 */
export const ADD_GW_BOTTOM_PRICE = (params: { code: string; price: string }) =>
  POST(`${HTTP}/product/addGwBottomPrice`, params, 'multipart/form-data')

export const GET_FORBID_CHAR = () =>
  GET<string>(`${HTTP}/product/getOctalValueGreaterThan128`)
import { TableRes } from '../global'
import { adjustTypeList } from '../pages/MaterialPriceAdjustment'
import request from '../tools/request'
import { GetLocalStorage, getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
const { GET, POST, downFilePost } = request

// 物料库存详情
export type ReturnDetail = {
  brandName: string
  code: string
  isDelisting: string
  isFreeShipping: string
  isPhaseOut: string
  areaInventoryList: any[]
  manuCode: string
  marketPrice: string
  mdmId: string
  name: string
  netWeight: string
  pushPlatformCodeAndNames: any[]
  relationPlatformCodeAndNames: any[]
  srmProductType: string
  srmProductTypeName: string
  supplyPrice: string
  unitName: string
}

// 获取库存管理列表
export const GET_STOCK_LIST = (param: {
  pageNo: number
  pageSize: number
  model: string
  productCode: string
  productName: string
  schemeId: string
  supplierId: string
  userId: string
  platformCode: string
}) =>
  GET<TableRes<ReturnDetail>>(`${HTTP}/product/getNewStockList`, {
    ...param,
    supplierId: getSupplierId(),
    mdmCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
  })

// 修改物料库存
export const UPDATE_STOCK = (params: {
  inventoryInformation: any
  productCode: string
  platformCode: string
}) =>
  POST(
    `${HTTP}/product/updateNewStock`,
    {
      ...params,
      userName: GetLocalStorage('USER_NAME'),
    },
    'application/json',
  )

// 获取当前项目
export const GET_PROJECT = () =>
  GET(`${HTTP}/product/getSupplierPerformanceDTOList`, {
    supplierId: getSupplierId(),
  })

// 获取库存区域详情
export const GET_INVENTORYDETAIL = (params: {
  productCode: string
  platformCode: string
}) =>
  GET(`${HTTP}/product/getMDMProductInventoryDetail`, {
    ...params,
  })

// 根据平台编码查询地址信息(对接MPM第三方平台)
export const GET_PRODUCTAREA = (params: { platformCode: string }) =>
  GET(`${HTTP}/product/getMDMAddressByType`, {
    ...params,
  })

// 下载导入模板
export const DOWNLOAD_PRODUCT = (params: { platformCode: string }) =>
  downFilePost(
    `${HTTP}/product/productStockImportForPlatformAddress?platformCode=${params.platformCode}`,
  )

// 修改库存状态
export const UPDATE_STOCKSTATUS = (params: {
  inventoryStatus: string
  id: string
}) =>
  POST(
    `${HTTP}/product/updateStockStatus`,
    {
      ...params,
      supplierId: getSupplierId(),
      supplierName: GetLocalStorage('HOME_DATA')?.enterpriseName,
    },
    'application/json',
  )

// 导出库存物料
export const PRODUCT_STOCK_EXPORT = (params: {
  platformCode: string
  platformName: string | undefined
}) =>
  POST(
    `${HTTP}/product/productStockExport`,
    {
      ...params,
      supplierId: getSupplierId(),
      userId: getUserId(),
      mdmCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
    },
    'multipart/form-data',
  )

// 导入库存物料
export const PRODUCT_STOCK_IMPORT = (params: {
  file: any
  platformCode: string
}) =>
  POST(
    `${HTTP}/product/productStockImport`,
    {
      ...params,
      supplierId: getSupplierId(),
      userId: getUserId(),
    },
    'multipart/form-data',
  )

// 国网物料
export interface GwProductItem {
  mallLink: any
  adjustPrice: boolean // 是否可调价
  brandName: string // 品牌名称
  causeOfRejection: string // 驳回原因
  code: string // 物料编码
  gwCode: string // 国网物料编码
  gwProductSerialNumber: string // 国网商品编码
  highestChangePrice: string // 最高可改价
  lastCause: boolean // 上次是否驳回
  name: string // 物料名称
  regionalPrice: string // 专区价
  manuCode: string // 规格型号
}

// 获取国网物料列表
export const GET_GW_PLATFORM_PRODUCT_PAGE = (param: {
  gwCode: string // 国网物料编码
  pageNo: number
  pageSize: number
  proName: string // 物料名称
  productCode: string // 物料编码
  schemeId: string
}) =>
  GET<TableRes<GwProductItem>>(`${HTTP}/product/getGwPlatformProductPage`, {
    ...param,
    supplierCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
    userId: getUserId(),
  })

// 获取国网物料列表权限
export const GET_GW_PLATFORM_PRODUCT_PERMISSION = () =>
  GET(`${HTTP}/product/getGwPlatformProductPermission`)

// 国网物料调价入参
type AdjustTypeKey = (typeof adjustTypeList)[number]['key']
export interface AdjustPriceParams {
  id: string
  code: string // 物料编码
  adjustType: AdjustTypeKey // 调价类型
  remark?: string // 备注
  adjustPrice?: string // 调价金额
}

// 国网物料调价
export const APPLY_FOR_PRICE_ADJUSTMENT = (params: AdjustPriceParams) =>
  POST(
    `${HTTP}/product/applyForPriceAdjustment`,
    {
      ...params,
      supplierCode: GetLocalStorage('SUPPLIER_MDM_CODE'),
      supplierId: getSupplierId(),
      supplierName: GetLocalStorage('HOME_DATA')?.enterpriseName,
    },
    'application/json',
  )

/**
 * 唤醒机器人 获取id
 * @param gwProductSerialNumber 国网商品编码
 */
export const ROUSE_ROBOT = (params: { gwProductSerialNumber: string }) =>
  GET(`${HTTP}/product/rouseRobot`, params)

/**
 * 根据id获取价格
 * @param gwProductSerialNumber  国网商品编码
 * @param taskId  任务id
 */
export const QUERY_ROBOT_EXECUTION_RESULT = (params: {
  taskId: string
  gwProductSerialNumber: string
}) => GET(`${HTTP}/product/queryRobotExecutionResult`, params)

/**
 * 保存国网最低价
 * @param code 物料编码
 * @param price 最低价
 */
export const ADD_GW_BOTTOM_PRICE = (params: { code: string; price: string }) =>
  POST(`${HTTP}/product/addGwBottomPrice`, params, 'multipart/form-data')

export const GET_FORBID_CHAR = () =>
  GET<string>(`${HTTP}/product/getOctalValueGreaterThan128`)
